export default {"src":"/_next/static/media/water.4a62bd6c.svg","height":300,"width":300};